import React from 'react';

const ContactUsPart = props => {
  return (
    <>
      <style jsx global>{`
               .borderedElement::after{
                                content:"";
                                position:absolute;
                                height:0;
                                width:360px;
                                border:1px solid white;
                                top:20px;
                                left:35px
                            }
                            .borderedElement::before{
                                content:"";
                                position:absolute;
                                position:absolute;
                                height:0;
                                width:360px;
                                border:1px solid white;
                                bottom:20px;
                                left:165px
                            }
                            @keyframes pulse {
                                0% {
                                    opacity: 0;
                                    background-position: center top;
                                    background-size: 0 auto;
                                }
                                10% {
                                    opacity: 0;
                                }
                                50% {
                                    opacity: 1;
                                    background-size: 75% auto;
                                }
                                90% {
                                    opacity: 0;
                                }
                                100% {
                                    opacity: 0;
                                    background-position: center bottom;
                                    background-size: 0 auto;
                                }
                            }
                            .filterClose{
                                border-bottom: 1px solid rgb(0 0 0 / 5%);
                            }
                         span#findUsContact a:after {
                            border-color:white;
                            color:black;
                         }
                          span#findUsContact a:before {
                            background: white;
                            color:black;
                            border-color:white;
                            transform: rotateY(0deg) translateZ(15px);
                          }
                              .perspective-1000{
                                perspective:1000px;
                                display: inline-flex;
                                width: 154px;
                                height: 40px;
                               }
                              .perspective-1000 a{
                                transform-style: preserve-3d;
                                transform: translateZ(-0px);
                                transition: transform .25s;
                              }
                               span#findUsContact a :before,
                             span#findUsContact a :after{
                                content: "we’re hiring";
                                height: 40px;
                                width: 154px;
                                position: absolute;
                                display: flex;
                                align-items: center;
                                justify-content: center;
                                border: 1px solid white!important;
                                box-sizing: border-box;
                                border-radius: 5px;
                                color: #fff;
                                font-size:18px
        
                            }
                         
                            .findUsContact :after{
                                font-weight: 400;
                                color:#670F7A!important;
                                transform: rotateX(90deg) translateZ(15px);
                            }
                           .findUsContact :hover{
                                transform: translateZ(-15px) rotateX(-90deg);
                            }
                            @media screen and (max-width:1000px){
                                .borderedElement::before{
                                    content:unset
                                }
                                .borderedElement::after{
                                    top:66px;
                                    width:80%;
                                    left:20px
                                }
                                .borderedElement{
                                    margin-top:30px
                                }
                                .mediaELement{
                                    bottom:0px;
                                    background: url(/images/design/contactmobile.svg);
                                    background-size: contain;
                                    background-position:bottom;
                                    height:120px;
                                    padding-top:20px
                                }
                              
                                   
                            }
               
            }
            `}</style>
      <div className="relative bg-white h-370 md:h-205">
        <div className="green-path absolute    top-0 bg-green w-full h-238 md:h-95 hidden md:block" />
        <div className="relative md:absolute h-205 w-full top-0 flex items-center z-10">
          <div className="container">
            <div className="title w-full md:w-half font-black text-24 text-purple leading-29 uppercase  pt-70 md:pt-0 mb-30 md:mb-0">
              We're Hiring
            </div>
            <div className="line bg-black mt-15 w-10p h-2" />
            <p className="mt-15  w-full md:w-half text-black text-16 leading-250 max-w-650">
              Our dedicated team is constantly growing, engaging new professionals for the accomplishment of business goals and partner projects. Find
              your next step to career growth with Prodigi.
            </p>
          </div>
        </div>
        <div className="w-full md:w-half pl-0 absolute container right-0 top-64p md:top-0 h-150   z-10 flex items-center justify-center  contactInfo  pr-10 text-center md:text-right  ">
          <span
            onClick={() => {
              window.open('/careers', '_self');
            }}
            id={'findUsContact'}
            className="perspective-1000 contact contactUs ml-0  md:ml-160"
          >
            <a href="/careers" className={'shadow-2xl findUsContact relative inline-block'} />
          </span>
        </div>
        <div className={'w-full   relative md:absolute right-0  mediaELement h-150 md:h-205 text-95'}>
          <div className="hidden md:flex absolute top-0 right-0 h-full  flex-col items-end justify-between">
            <img src={'/images/about/careers(1).svg'} width={548} height={96} alt={'contact'} />
            <img src={'/images/about/careers(2).svg'} width={636} height={97} alt={'contact'} />
          </div>
        </div>
      </div>
      <style jsx global>{`
        .green-path {
          height: 205px;
          -webkit-clip-path: polygon(77.5% 0, 100% 0%, 100% 100%, 69% 100%);
          clip-path: polygon(77.5% 0, 100% 0%, 100% 100%, 69% 100%);
        }

        @media screen and (max-width: 1000px) {
          .green-path {
            clip-path: unset;
          }
        }
      `}</style>
    </>
  );
};
export default ContactUsPart;
